import { conditionalBranchMessage } from '../functions'

export default {
  function: {
    upload_common: {
      conditional_branch_message: (args: any) =>
        conditionalBranchMessage(args, (triggerQuestionSelectMetaList) => {
          if (triggerQuestionSelectMetaList.length === 1) {
            const { categoryName, questionDisplayNumber, selectText } = triggerQuestionSelectMetaList[0]
            return `สำหรับผู้ที่ตอบ '${selectText}' ในข้อ ${questionDisplayNumber} ของ ${categoryName} (คำถามบังคับ)`
          }

          const messages = triggerQuestionSelectMetaList.map(
            ({ categoryName, questionDisplayNumber, selectText }) => {
              return `'${selectText}' ในข้อ ${questionDisplayNumber} ของ ${categoryName}`
            }
          )
          return `สำหรับผู้ที่ตอบ ${messages.join(' หรือ ')} (คำถามบังคับ)`
        }),
    },
    validation: {
      decimal_max_digit: 'พิมพ์ได้สูงสุดถึงทศนิยม {decimalMaxDigit} ตำแหน่ง',
    },
  }
}
